import React from 'react'
import './adminbottomnav.css'
import { Link } from 'react-router-dom';

function AdminBottomNav() {
    return (
        <div className="admin-bottom-nav">
             <ul className="nav-wrapper">
                <Link to="/admin" ><li className="bottom-nav-item"><i className="fas fa-home"></i></li></Link>
                <Link to="/admin" ><li className="bottom-nav-item"><i className="fas fa-plus-circle"></i></li></Link>
                <Link to="/admin" ><li className="bottom-nav-item"><i className="fas fa-sliders-h"></i></li></Link>
                <Link to="/settings" ><li className="bottom-nav-item"><i className="fas fa-cog"></i></li></Link>
            </ul>            
        </div>
    )
}

export default AdminBottomNav
